import { useSwiperContext } from '../components/SwiperContext/SwiperContext';

export const useSwiperController = () => {
  const { activeIndex, setActiveIndex } = useSwiperContext();

  const handleNextClick = (length?: number) => {
    if (length && activeIndex >= length) {
      setActiveIndex(0);
    } else {
      setActiveIndex(activeIndex + 1);
    }
  };
  const handlePrevClick = () => {
    setActiveIndex(activeIndex - 1);
  };
  const handleSlideTo = (newIndex: number) => {
    setActiveIndex(newIndex);
  };

  return {
    activeIndex,
    handleNextClick,
    handlePrevClick,
    handleSlideTo,
  };
};

export interface SwiperController {
  activeIndex: number;
  handleNextClick: (length?: number) => void;
  handlePrevClick: (length?: number) => void;
  handleSlideTo: (newIndex: number) => void;
}
